import React from 'react';
import './styles.scss';
import { Col, Row } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { LoginStatus } from '../LoginStatus';

export const AppBar = () => {
    return (
        <Row className="appBar">
            <Col className="appBarName">
                <FormattedMessage id="appName" />
            </Col>

            <Col className="appBarContent">
                <LoginStatus />
            </Col>
        </Row>
    );
};
